import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { CustomerGroupTree, ICustomerGroupTreeProps } from './CustomerGroupTree';

const GetCustomerGroupListQuery = gql`
  query {
    customerGroupList {
      id
      name
    }
  }
`;

export default withRouter(compose<{}, ICustomerGroupTreeProps>(
  graphql<ICustomerGroupTreeProps, any>(GetCustomerGroupListQuery, {
    name: 'customerGroupList',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ customerGroupList }: any) => {
    return {
      customerGroupList: customerGroupList.customerGroupList,
    };
  }),
)(CustomerGroupTree));



// WEBPACK FOOTER //
// ./src/components/Others/CustomerGroupTree/index.ts